export default "__VITE_ASSET__C745UbRg__"